<template>
  <div>
    <Nav />
    <div class="content-wrap">
      <div style="padding:20px 0 30px 0;">
        <el-button v-if='IsPrintedPage' :style="btnAllStyle" type="primary" class="down-btn" @click="getVisitor" :loading="showBtnLoading">下载确认函</el-button>
      </div>
      <iframe class="iframe" :src="infoSrc"></iframe>
    </div>
    <div class="meetingMain" v-if="IsRegistActivity">
      <h3 class="title">已报名会议</h3>
      <div class="meetList" v-if="payMeeting&&payMeeting.length>0">
        <el-table
          :data="payMeeting"
          style="width: 100%">
          <el-table-column
            prop="AtyTheme"
            label="名称"
            width="180">
          </el-table-column>
          <el-table-column
            label="时间"
            width="240">
            <template slot-scope="scope">{{scope.row.AtyDate+ ' ' +scope.row.AtyBTime + '-' + scope.row.AtyETime}}</template>
          </el-table-column>
          <el-table-column
            prop="AtyPlace"
            label="地点">
          </el-table-column>
          <el-table-column
            prop="AtyContent"
            label="详情">
          </el-table-column>
        </el-table>
      </div>
      <div style="text-align:center; padding:20px 0;" v-else>
        <div style="padding:10px 0 20px 0">您还没有报名会议</div>
        <el-button class="bmBtn" @click="toMeeting" :style="btnAllStyle">报名会议</el-button>
      </div>
    </div>
    <div class="extendInfo" v-html="ExtendInfo"></div>
    <div class="adImg"><img :src="FooterAdImage" alt=""></div>
  </div>
</template>
<script>
import api from '../api'
import Nav from '../components/Nav'
import utils from '../utils'
export default {
  name: 'Confirmation',
  components: {
    Nav
  },
  data() {
    return {
      successHtml: '',
      infoSrc: '',
      ExhID: sessionStorage.getItem('ExhID'),
      IsPrintedPage: false,
      showBtnLoading: false,
      ExtendInfo: '',
      FooterAdImage: '',
      btnAllStyle: sessionStorage.getItem('btnAll') ? JSON.parse(sessionStorage.getItem('btnAll')).styles : {},
      payMeeting: [],
      IsRegistActivity: sessionStorage.getItem('IsRegistActivity') ? JSON.parse(sessionStorage.getItem('IsRegistActivity')) : true
    }
  },
  mounted() {
    if (this.ExhID) {
      this.getUserInfo()
      this.getConfigInfo()
      this.initData()
      if (this.IsRegistActivity) {
        this.getPersonAty()
      }
    }
    utils.setThemeColor()
  },
  methods: {
    getPersonAty () {
      api.getPersonAty({
        ExhID: this.ExhID,
        PsjID: sessionStorage.getItem('PsjID')
      }).then(res => {
        if (res.data.status === 'OK') {
          res.data.data.map(item => {
            item.AtyDate = item.AtyDate.split(' ')[0]
          })
          this.payMeeting = res.data.data
        } else {
          this.$alert(res.data.ErrorMsg, '提示')
        }
      })
    },
    toMeeting() {
      this.$router.push({path: '/meeting', query: {ExhID: sessionStorage.getItem('ExhID')}});
    },
    getVisitor () {
      var _this = this
      _this.showBtnLoading = true
      var param = {
        exhid: this.ExhID,
        psjid: sessionStorage.getItem('PsjID')
      };
      api.getConfirmPdf(param).then(res => {
        _this.showBtnLoading = false
        if(res.data.status == 'OK') {
          var url = res.data.pdfUrl
          url = url.replace('http:', 'https:')
          window.open(url);
        }else{
          _this.$alert(res.data.ErrorMsg, '提示')
        }
      })
    },
    getUserInfo () {
      var successInfo = {
        exhid: this.ExhID,
        EntryPsjId: sessionStorage.getItem('PsjID'),
        Language:'cn'
      }
      var loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      api.visitorStrategy(successInfo).then(
        res => {
          loading.close()
          if (res.data.status === 'OK') {
            this.infoSrc = res.data.HtmlInfo
            this.$store.commit('setVisitorID', res.data.PsnID)
            // sessionStorage.setItem('PsnID', res.data.PsnID)
            sessionStorage.setItem('PsnID', res.data.EntryPsnID)
            sessionStorage.setItem('noJmPsnID', res.data.PsnID)
            sessionStorage.setItem('PsnName', res.data.PsnName)
          } else {
            this.$alert(res.data.ErrorMsg, '提示')
          }
        },
        error => {
          loading.close()
          console.log(error)
        }
      )
    },
    getConfigInfo() {
      var That = this
      var param = {
        ExhID: this.ExhID,
        RegistType: 'pc',
        page: 'successpage'
      }
      api.getPage(param).then(res => {
        if(res.data.status === 'OK') {
          res.data.promptinfo.forEach(ele => {
            if(ele.name === 'PageTips') {
              That.successHtml = ele.value
            }
            if(ele.name === 'ExtendInfo') {
              That.ExtendInfo = ele.value
            }
          })
          res.data.switchInfos.forEach(ele => {
            if(ele.name === 'IsPrintedPage') {
              That.IsPrintedPage = ele.data
            }
          })
          res.data.images.map(item => {
            if (item.name === 'FooterAdImage') {
              That.FooterAdImage = item.data[0]
            }
          })
        }else{
          That.$alert(res.data.ErrorMsg)
        }
      })
    },
    initData() {
      var _PsjID = sessionStorage.getItem('PsjID') || ''
      if (_PsjID !='') {
        api
          .getRegistInfo({
            ExhID: this.ExhID,
            PsjID: _PsjID
          })
          .then(res => {
            if (res.data.status === 'OK') {
              sessionStorage.setItem('dataInfo', JSON.stringify( res.data.Data))
            }
          })
      }
    },
  }
}
</script>
<style lang="scss">
.content-wrap{
  background: #fff;
  text-align: center;
  padding-top:30px;
}
.iframe {
  width: 80%;
  max-width: 720px;
  min-height: 700px;
  background: #fff;
  border: none;
  display: inline-block;
}
.adImg img{
  width: 100%;
  margin-top: 20px;
}
.meetingMain{
  padding: 10px 20px;
  box-shadow: 1px 1px 12px #dedede;
  margin-top: 20px;
  background: #fff;
  .title{
    font-weight: normal;
    padding: 30px 0;
    border-bottom: 1px solid #dedede;
  }
  .meetList{
    padding: 45px 0;
  }
  .bmBtn.el-button{
    width: 20% !important;
    position: static !important;
    color: #FFF;
    background-color: #409EFF;
    border-color: #409EFF;
    margin: 0 30px;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/Confirmation.vue